import * as React from 'react';

import { Page } from './page/page.component';

export class AboutPage extends React.PureComponent {
  public render() {
    return (
      <div className="about-page" />
    );
  }
}
